import { IonicSafeString } from '@ionic/angular';
import { normalizeMojibakeText } from './text-normalizer';

const ALLOWED_TAGS = new Set([
  'B',
  'BR',
  'DIV',
  'EM',
  'H3',
  'ION-ICON',
  'LI',
  'P',
  'SMALL',
  'SPAN',
  'STRONG',
  'UL'
]);

const REMOVED_WITH_CONTENT = new Set([
  'IFRAME',
  'OBJECT',
  'SCRIPT',
  'STYLE'
]);

/**
 * Prepara mensagens HTML para os overlays do Ionic 8.
 * Somente tags visuais conhecidas são mantidas; eventos e demais atributos são removidos.
 */
export function ionicSafeHtml(value: unknown): IonicSafeString {
  const html = normalizeMojibakeText(String(value ?? ''));

  if (typeof document === 'undefined') {
    return new IonicSafeString(html.replace(/<[^>]*>/g, ''));
  }

  const template = document.createElement('template');
  template.innerHTML = html;
  sanitizeChildren(template.content);

  return new IonicSafeString(template.innerHTML);
}

function sanitizeChildren(parent: ParentNode): void {
  Array.from(parent.childNodes).forEach((node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const element = node as HTMLElement;

    if (REMOVED_WITH_CONTENT.has(element.tagName)) {
      element.remove();
      return;
    }

    if (!ALLOWED_TAGS.has(element.tagName)) {
      sanitizeChildren(element);
      element.replaceWith(...Array.from(element.childNodes));
      return;
    }

    Array.from(element.attributes).forEach((attribute) => {
      const keepClass = attribute.name === 'class';
      const keepIconName = element.tagName === 'ION-ICON' && attribute.name === 'name';

      if (!keepClass && !keepIconName) {
        element.removeAttribute(attribute.name);
      }
    });

    sanitizeChildren(element);
  });
}
